import { useQuery } from '@tanstack/react-query';

import { fetchMyCourses } from './courseApi';

/**
 * Resolves a course the signed-in student is actually enrolled in, so links such as
 * "Ma progression" never target a placeholder id (e.g. "first") that the student hasn't
 * joined yet, which the API rejects as an invalid course id.
 */
export function useStudentCourseId(preferredCourseId: string, enabled = true) {
  const coursesQuery = useQuery({
    queryKey: ['student', 'my-courses'],
    queryFn: fetchMyCourses,
    enabled,
  });
  const courses = coursesQuery.data ?? [];
  const isPreferredEnrolled = courses.some((course) => course.id === preferredCourseId);
  const courseId = isPreferredEnrolled ? preferredCourseId : (courses[0]?.id ?? null);

  return {
    courseId,
    isLoading: coursesQuery.isLoading,
  };
}
